<template>
  <PBadge v-if="dueIn <= 8" type="error">
    <span v-if="dueIn >= 1">J - {{ Math.max(dueIn, 0) }}</span>
    <span v-else-if="dueIn === 0">Dernier jour</span>
    <span v-else>retard</span>
  </PBadge>
</template>

<script setup lang="ts">
import { computed } from "vue";
import dayjs from "dayjs";
import { PBadge } from "@pasta/box-v2";
import { type LetterFileDto } from "../dto/letter-file.dto";

interface Props {
  letterFile: LetterFileDto;
}
const props = defineProps<Props>();

const dueIn = computed<number>(() => {
  if (!props.letterFile.deadline) return Number.MAX_SAFE_INTEGER;
  return dayjs(props.letterFile.deadline).diff(dayjs(new Date().setHours(0, 0, 0, 0)), "day");
});
</script>
